import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import Footer from '../../organisms/footer/footer'
import Header from '../../organisms/header/header'
import Main from '../main'

const LightLayout = ({ children, layout: layoutProps }) => {
	const {
		layout: { default: layoutConfig },
	} = useConfig()

	const layout = { ...layoutConfig, ...layoutProps }

	return (
		<>
			<Main
				beforeContent={<Header type="filled" variant="restricted" />}
				afterContent={<Footer variant="restricted" />}
				layout={layout}
			>
				{children}
			</Main>
		</>
	)
}

export default LightLayout
